import { render, staticRenderFns } from "./SiteRevenueAdd.vue?vue&type=template&id=070f0ee7"
import script from "./SiteRevenueAdd.vue?vue&type=script&lang=js"
export * from "./SiteRevenueAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports